import { usePresentation } from '@/hooks/Presentation';
import { Tooltip } from '@chakra-ui/react';

import { IconStart, IconStop, PresentationButton } from './styles';

export function Presentation() {
  const {
    isPresenting,
    startPresentation,
    stopPresentation,
  } = usePresentation();

  function handleStartPresentation() {
    !isPresenting ? startPresentation() : stopPresentation();
  }

  const label = isPresenting ? 'Parar apresentação' : 'Iniciar apresentação';

  return (
    <Tooltip label={label}>
      <PresentationButton onClick={handleStartPresentation}>
        {isPresenting ? <IconStop /> : <IconStart />}
      </PresentationButton>
    </Tooltip>
  );
}
